import { graphql } from "@opensea/graphql"
import { ItemRewardCardFragment } from "./ItemRewardCard.fragment"
import {
  SortRewardsByValue_itemFragment,
  SortRewardsByValue_tokenFragment,
} from "./sortRewardsByValue"
import { TokenRewardCardFragment } from "./TokenRewardCard.fragment"
import { TreasureRewardCardFragment } from "./TreasureRewardCard.fragment"

export const OpenTreasureChestModal_treasureFragment = graphql(
  `
    fragment OpenTreasureChestModal_treasure on Badge {
      __typename
      id
      name
      ...TreasureRewardCard
    }
  `,
  [TreasureRewardCardFragment],
)

export const OpenTreasureChestModalFragment = graphql(
  `
    fragment OpenTreasureChestModal on TreasureChest {
      id
      chestLevels {
        level
        pointsRequired
      }
      userProgress {
        totalPoints
        hasExceededLevelCap
        currentLevel
        currentTier
        progressPercent
      }
      userRewards {
        __typename
        id
        treasureChestId
        claimedAt
        ...ItemRewardCard
        ...SortRewardsByValue_item
      }
      userTokenRewards {
        __typename
        id
        treasureChestId
        claimedAt
        ...TokenRewardCard
        ...SortRewardsByValue_token
      }
      userTreasures {
        ...OpenTreasureChestModal_treasure
      }
    }
  `,
  [
    ItemRewardCardFragment,
    SortRewardsByValue_itemFragment,
    TokenRewardCardFragment,
    SortRewardsByValue_tokenFragment,
    OpenTreasureChestModal_treasureFragment,
  ],
)
